import { IdentificationType } from './identification-type';

export class PartnerIdentificationType {
    PartnerIdentificationTypeId: number;
    Value: string;
    IsMainIdentification: boolean;
    PartnerId: number;
    IdentificationType: IdentificationType;
    Description: string;
}
